import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { NipFieldsService } from 'src/app/nip/core/nip-fields.service';
import { Nip } from 'src/app/_models/nip';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { MessService } from 'src/app/_services/mess-service.service';
import { NipService } from 'src/app/_services/nip.service';
import { OperationsService } from 'src/app/_services/operations.service';

@Component({
  selector: 'app-nip-worker-edit-improved',
  templateUrl: './nip-worker-edit-improved.component.html',
  styleUrls: ['./nip-worker-edit-improved.component.scss'],
  providers: [DatePipe],
})
export class NipWorkerEditImprovedComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  id: number;

  operationsForDropdown = [];
  loading = true;
  started = false;
  stopped = false;
  notSaved = false;
  pauseStart = false;
  pauseStop = false;
  disabledStart = false;
  disablePauseStart = false;

  pausedTime = 0;
  totalTime: string;

  subOperationSelected = false;
  selectedOperation: any;
  idOfSelectedSuboperation: number;
  subOpFromAvailableProdOp: any;
  arrOfSuboperation = [];

  saveNipForm: FormGroup;
  startNipForm: FormGroup;
  stopNipForm: FormGroup;
  delayReasonsForm: FormGroup;

  timeStart: Date;
  timeStop: Date;

  nipForUpdate: any = new Nip();

  editNipActive = false;
  nipOnStartForm: any;

  activeNip: any;

  displayModal: boolean = false;

  delayReasons = [
    { name: '0 - Ostalo', code: 'other' },
    { name: '1 - Pauza za ručak', code: 'lunch_break' },
    { name: '2 - Pauza za odmor', code: 'rest_break' },
    {
      name: '3 - Pomoć-Prijem/utovar robe',
      code: 'help_reciving_delivery_package',
    },
    { name: '4 - Kvar-Mašina/Alatr', code: 'failure' },
    { name: '5 - Pomoć kolegi u proizvodnji', code: 'helping_colleague' },
    { name: '6 - Obuka radnika', code: 'training_workers' },
    { name: '7 - Nedostatak-Materijal', code: 'no_material' },
    { name: '8 - Nedostatak-TD', code: 'no_td' },
    { name: '9 - Sastanak', code: 'meeting' },
  ];

  delayTime = new Date('January 31 2000 0:0');
  chosenOperation: number;

  scrapReasons = [
    { name: 'Ljudski faktor', code: 'human_factor' },
    { name: 'Nejasna TD', code: 'no_defined_td' },
    { name: 'Kvalitet materijala', code: 'material_quality' },
    { name: 'Ispravnost mašine', code: 'machine_failure' },
    { name: 'Ostalo', code: 'other' },
  ];

  allOperations = [];
  allSubOperations = [];

  constructor(
    private nipService: NipService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public fieldsService: NipFieldsService,
    private datePipe: DatePipe,
    private authService: AuthenticationService,
    private messService: MessService,
    private operationsService: OperationsService,
    private cdr: ChangeDetectorRef
  ) {}

  /* ====================================
     *              LIFECYCLES
     ======================================= */
  ngOnInit(): void {
    this.id = this.route.snapshot.params['id'];
    this.getData(this.id);

    // * Get all operations
    this.subscriptions.push(
      this.operationsService.getAllNoPagination().subscribe((res) => {
        this.allOperations = res;
        console.log(this.allOperations);
      })
    );

    // * Delay reasons form for start/stop pause
    this.delayReasonsForm = this.fb.group({
      delay_reasons: [[]],
    });

    // * Create form for START
    this.startNipForm = this.fb.group({
      product_operation_rel_id: [''],
      suboperation_id: [''],
    });

    // * Create form for STOP
    this.stopNipForm = this.fb.group({
      product_operation_rel_id: [''],
      product_suboperation_rel_id: [''],
    });

    this.editNipActive = false;
    // * Create form for SAVE
    this.saveNipForm = this.fb.group({
      product_operation_rel_id: [{ value: '' }, Validators.required],
      documentation_correct: [],
      produced_amount: ['', Validators.required],
      scrap_reasons: [[]],
      // delay_reasons: [[]],
      // delay_duration: [''],allOperations
      scrap_amount: [''],
      comment: [''],
      operation_id: ['', Validators.required],
      suboperation_id: [''],
    });

    this.cdr.detectChanges();

    // this.updateNipData();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
     *             MAIN FEATURES
     ======================================= */

  getData(id) {
    this.loading = true;

    this.subscriptions.push(
      this.nipService.getOneWorkNip(id).subscribe({
        complete() {},
        next: (response: any) => {
          this.loading = false;
          this.arrOfSuboperation =
            response?.available_prod_ops[0]?.suboperations;
          this.setUpdateNipData(response);

          // this.cdr.detectChanges();
        },
        error: (err: any) => {},
      })
    );
  }

  /* ====================================
  *                HELPERS
  ======================================= */
  setUpdateNipData(nip: any) {
    // nip = {
    //   ...nip,
    //   allSubOperations: nip.available_prod_ops[0],
    // };
    this.activeNip = nip;

    if (
      this.activeNip?.active_time_tracker !== null &&
      this.activeNip?.active_time_tracker?.active_break_tracker !== null
    ) {
      // this.pauseStart = true;
    }

    if (!nip) {
      this.router.navigate(['./../../'], { relativeTo: this.route });
      return;
    } else {
      this.nipForUpdate = nip;

      if (nip.active_time_tracker) {
        this.timeStart = new Date(nip.active_time_tracker.start);
        this.started = true;
        this.chosenOperation =
          nip?.active_time_tracker?.product_operation_rel_id;

        this.totalTime = nip?.active_time_tracker?.total_time;

        this.saveNipForm.patchValue({
          product_operation_rel_id:
            nip?.active_time_tracker?.product_operation_rel_id,
        });

        this.stopNipForm.patchValue({
          product_operation_rel_id:
            nip?.active_time_tracker?.product_operation_rel_id,
        });

        // * Remove validation for operation_id if active_time_tracker is active and has value
        this.saveNipForm.get('operation_id').clearValidators();
      }
      if (nip?.active_time_tracker && nip?.active_time_tracker.end) {
        this.timeStop = new Date(nip.active_time_tracker.end);
        this.notSaved = true;
      }

      this.startNipForm.patchValue({
        product_operation_rel_id: nip?.current_product_operation_rel_id,
      });

      if (this.nipForUpdate.available_prod_ops[0]) {
        console.log('IF 1', this.nipForUpdate.available_prod_ops[0]);

        this.choseOperationForWork(this.nipForUpdate.available_prod_ops[0].id);
      }

      if (this.nipForUpdate?.active_time_tracker) {
        this.choseOperationForWork(
          this.nipForUpdate?.active_time_tracker?.product_operation_rel_id
        );
      }

      if (this.nipForUpdate?.enable_add_operations) {
        this.startNipForm.addControl('operation_id', this.fb.control(''));
        this.startNipForm.removeControl('product_operation_rel_id');
      }

      this.selectedOperation = nip?.available_prod_ops[0]?.id;

      const { product_operation_rel_id } = this.saveNipForm.value;
      const { planned_units, produced_totals } = nip;
      const produced_total = produced_totals[product_operation_rel_id];
      const total_produced = planned_units - produced_total;

      this.selectedOperation = this.nipForUpdate?.current_op?.id;
      this.subOpFromAvailableProdOp =
        this.nipForUpdate.available_prod_ops[0]?.suboperations;

      // if (total_produced > 0) {
      //   this.saveNipForm
      //     .get('produced_amount')
      //     .setValidators([Validators.max(planned_units - produced_total)]);
      // }
      if (nip?.active_time_tracker?.start) {
        this.started = true;
      }

      if (nip?.active_time_tracker?.end) {
        this.stopped = true;
      }

      if (
        nip?.active_time_tracker?.active_break_tracker?.start &&
        !nip?.active_time_tracker?.active_break_tracker?.end
      ) {
        this.pauseStart = true;
      }
    }

    this.cdr.detectChanges();
  }

  updateNipData() {
    // * Get data for update
    this.subscriptions.push(
      this.nipService.updateNipData.subscribe((nip: Nip) => {
        this.arrOfSuboperation = nip?.available_prod_ops[0]?.suboperations;
        this.setUpdateNipData(nip);
      })
    );
  }

  enableSave() {
    const saveNip = this.saveNipForm.getRawValue();

    if (saveNip.produced_amount && saveNip.documentation_correct) {
      this.saveNipForm.valid;
    }
  }
  // * SAVE NIP === //
  onSaveNip() {
    const saveNip = this.saveNipForm.getRawValue();

    saveNip.product_operation_rel_id = this.chosenOperation;

    const subOperationValue =
      this.activeNip.active_time_tracker.product_suboperation_rel_id;
    saveNip.product_suboperation_rel_id = subOperationValue;

    this.subscriptions.push(
      this.nipService.saveNip(this.nipForUpdate.id, saveNip).subscribe(
        (success) => {
          this.messService.add({
            severity: 'success',
            title: 'Merenje vremena',
            detail: 'Uspešno ste sačuvali unos.',
          });
          this.router.navigate(['./../../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.saveNipForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );

    // if (this.nipForUpdate.enable_add_operations === false) {
    //   saveNip.product_operation_rel_id = saveNip.product_operation_rel_id;

    //   // this.arrOfSuboperation.forEach((operation) => {
    //   //   if (
    //   //     this.activeNip.active_time_tracker.product_suboperation_rel_id ===
    //   //     operation.suboperation_id
    //   //   ) {
    //   //     saveNip.product_suboperation_rel_id = operation.id;
    //   //   }
    //   // });
    // }
    // if (this.nipForUpdate.enable_add_operations) {
    //   const subOperationValue =
    //     this.activeNip.active_time_tracker.product_suboperation_rel_id;
    //   saveNip.product_suboperation_rel_id = subOperationValue;
    // }
  }

  // * START === //
  onStart() {
    this.disabledStart = true;

    // setTimeout(() => {
    //   this.disabledStart = false;
    // }, 400);

    const nipStart = this.startNipForm.getRawValue();
    const subOperationValue = this.saveNipForm.getRawValue();
    nipStart.suboperation_id = subOperationValue.suboperation_id;
    this.nipOnStartForm = nipStart;
    let selectedOperation;

    console.log('nipStart', nipStart);
    console.log(this.arrOfSuboperation);

    if (!this.nipForUpdate.enable_add_operations) {
      delete Object.assign(nipStart, {
        product_suboperation_rel_id: nipStart.suboperation_id,
      })['suboperation_id'];
    }

    this.nipForUpdate.available_prod_ops.forEach((operation) => {
      if (operation.id === nipStart.product_operation_rel_id) {
        selectedOperation = operation;
      }
    });

    if (this.nipForUpdate.available_prod_ops.length !== 0) {
      if (this.nipForUpdate.enable_add_operations === true) {
        nipStart.operation_id = this.chosenOperation;

        if (this.arrOfSuboperation.length !== 0) {
          this.arrOfSuboperation.forEach((operation) => {
            if (
              nipStart.product_suboperation_rel_id === operation.suboperation_id
            ) {
              nipStart.suboperation_id = operation.suboperation_id;
            }
          });
        }
      } else {
        nipStart.product_operation_rel_id = selectedOperation.id;

        this.nipForUpdate.available_prod_ops.forEach(
          (availableOperations, index) => {
            if (availableOperations.id === this.chosenOperation) {
              availableOperations.suboperations.forEach((subop) => {
                if (
                  subop.suboperation_id === nipStart.product_suboperation_rel_id
                ) {
                  nipStart.product_suboperation_rel_id = subop.id;
                }
              });
            }
          }
        );
      }
    }

    this.subscriptions.push(
      this.nipService.startNip(this.nipForUpdate.id, nipStart).subscribe(
        (success: any) => {
          if (success.status === 200) {
            this.started = true;

            this.timeStart = new Date();

            this.getData(this.nipForUpdate.id);
          }

          if (this.nipForUpdate.enable_add_operations) {
            this.choseOperationForWork(
              success.body[0].product_operation_rel_id
            );
          }

          this.messService.add({
            severity: 'success',
            title: 'Merenje vremena',
            detail: 'Uspešno ste pokrenuli merenje vremena.',
          });

          this.editNipActive = true;
          this.disabledStart = false;
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.startNipForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });

          this.disabledStart = false;
        }
      )
    );

    this.cdr.detectChanges();
  }

  // * STOP === //
  onStop() {
    // this.saveNipForm.patchValue({
    //   time_stop: new Date(),
    //   time: this.getTimeDiff(this.getControls.time_start.value, new Date()),
    // });

    const nipStop = this.stopNipForm.getRawValue();
    this.idOfSelectedSuboperation =
      this.activeNip.active_time_tracker.product_suboperation_rel_id;
    const subOperationValue =
      this.activeNip.active_time_tracker.product_suboperation_rel_id;
    nipStop.product_suboperation_rel_id = subOperationValue;

    this.subscriptions.push(
      this.nipService.stopNip(this.nipForUpdate.id, nipStop).subscribe(
        (success: any) => {
          if (success.total_time) {
            this.started = false;
            this.stopped = true;
            this.timeStop = new Date();
            this.totalTime = success.total_time;
          }

          this.messService.add({
            severity: 'success',
            title: 'Merenje vremena',
            detail: 'Uspešno ste zaustavili merenje vremena.',
          });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.stopNipForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );

    this.cdr.detectChanges();
  }

  onCancel() {
    const nipCancel = this.stopNipForm.getRawValue();

    this.subscriptions.push(
      this.nipService.cancelNip(this.nipForUpdate.id, nipCancel).subscribe(
        (success: any) => {
          this.messService.add({
            severity: 'success',
            title: 'Merenje vremena',
            detail: 'Uspešno ste otkazali merenje vremena.',
          });
          this.router.navigate(['./../../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.stopNipForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );
  }

  // * PAUSE START === //
  onStartPause() {
    this.displayModal = true;
    this.delayReasonsForm.reset();

    // const nipStartPause = this.stopNipForm.getRawValue();
    // const subOperationValue =
    //   this.activeNip.active_time_tracker.product_suboperation_rel_id;
    // nipStartPause.product_suboperation_rel_id = subOperationValue;

    // this.subscriptions.push(
    //   this.nipService.startPause(this.nipForUpdate.id, nipStartPause).subscribe(
    //     (success: any) => {
    //       if (success.total_time) {
    //         this.started = false;
    //         this.stopped = true;
    //         this.timeStop = new Date();
    //         this.totalTime = success.total_time;
    //       }

    //       this.messService.add({
    //         severity: 'success',
    //         title: 'Merenje vremena',
    //         detail: 'Uspešno ste zaustavili merenje vremena.',
    //       });
    //     },
    //     (error) => {
    //       const errorObj = error.error.errors;
    //       const form = this.stopNipForm;
    //       const messService = this.messService;
    //       Object.keys(errorObj).forEach(function (key) {
    //         const formControl = form.get(key);
    //         if (formControl) {
    //           // If error exist set red border to field
    //           formControl.setErrors({});
    //         }
    //         // Push toast error for every field
    //         messService.addError({
    //           severity: 'error',
    //           title: 'Greška',
    //           detail: errorObj[key],
    //           sticky: true,
    //         });
    //       });
    //     }
    //   )
    // );

    this.cdr.detectChanges();
  }

  onStopPause() {
    this.pauseStart = false;
    this.pauseStop = true;

    const nipStartPause = this.stopNipForm.getRawValue();
    const subOperationValue =
      this.activeNip.active_time_tracker.product_suboperation_rel_id;
    nipStartPause.product_suboperation_rel_id = subOperationValue;

    this.subscriptions.push(
      this.nipService.stopPause(this.nipForUpdate.id, nipStartPause).subscribe(
        (success: any) => {
          if (success.total_time) {
            this.started = false;
            this.stopped = true;
            this.timeStop = new Date();
            this.totalTime = success.total_time;
          }

          this.messService.add({
            severity: 'success',
            title: 'Merenje vremena',
            detail: 'Uspešno ste zaustavili merenje vremena.',
          });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.stopNipForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );

    this.cdr.detectChanges();
  }

  onSavePause() {
    this.disablePauseStart = true;

    setTimeout(() => {
      this.disablePauseStart = false;
    }, 400);

    const nipStopPause = this.stopNipForm.getRawValue();
    const subOperationValue =
      this.activeNip?.active_time_tracker.product_suboperation_rel_id;
    nipStopPause.product_suboperation_rel_id = subOperationValue;

    let finalNip = {
      ...nipStopPause,
      ...this.delayReasonsForm.getRawValue(),
    };
    this.pauseStart = true;

    this.subscriptions.push(
      this.nipService.startPause(this.nipForUpdate.id, finalNip).subscribe(
        (success: any) => {
          if (success.total_time) {
            this.started = false;
            this.stopped = true;
            this.timeStop = new Date();
            this.totalTime = success.total_time;
          }

          this.messService.add({
            severity: 'success',
            title: 'Merenje vremena',
            detail: 'Uspešno ste započeli merenje vremena.',
          });

          this.displayModal = false;
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.stopNipForm;
          const messService = this.messService;
          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      )
    );

    this.cdr.detectChanges();
  }

  // * Helpers === //

  choseOperationForWork(event) {
    console.log(event);

    this.chosenOperation = event;

    this.startNipForm.patchValue({
      product_operation_rel_id: event,
    });

    this.stopNipForm.patchValue({
      product_operation_rel_id: event,
    });

    this.nipForUpdate.available_prod_ops.forEach((operation, index) => {
      if (operation?.id === event) {
        this.allSubOperations =
          this.nipForUpdate?.available_prod_ops[index]?.suboperations;
      }
    });

    this.cdr.detectChanges();
  }

  choseFromAllOperations(event) {
    console.log('CHOSE ALL OP', event);

    if (event) {
      this.allOperations.forEach((operation) => {
        if (operation.id === event) {
          this.allSubOperations = operation.suboperations;
        }
      });

      this.chosenOperation = event;
      this.startNipForm.patchValue({
        operation_id: event,
      });
    } else {
      this.allSubOperations = [];
    }

    console.log('AFTER CHOOSE', this.allSubOperations);

    this.cdr.detectChanges();
  }

  addReasonToForm(event, field) {
    this.delayReasonsForm.patchValue({
      [field]: event.value,
    });
  }

  onChoseDelayTime(event: Date) {
    let hours =
      event.getHours().toString.length < 2
        ? '0' + event.getHours()
        : event.getHours();
    let minutes =
      event.getMinutes().toString.length < 2
        ? '0' + event.getMinutes()
        : event.getMinutes();
    let seconds =
      event.getSeconds().toString.length < 2
        ? '0' + event.getSeconds()
        : event.getSeconds();
  }

  get getControls() {
    return (<FormGroup>this.saveNipForm).controls;
  }

  getTimeDiff(startDate, endDate) {
    let distance = Math.abs(startDate - endDate);
    const hours = Math.floor(distance / 3600000);
    distance -= hours * 3600000;
    const minutes = Math.floor(distance / 60000);
    distance -= minutes * 60000;
    const seconds = Math.floor(distance / 1000);

    return `${hours}:${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`;
  }

  suboperationSelected() {
    this.subOperationSelected = true;

    // // this.saveNipForm.controls.operation_id.invalid =false
    // this.saveNipForm.controls['operation_id'].clearValidators()
  }
}
